// AppDatePicker.jsx
// Date-only sibling of AppDateTimePicker (see that file for the full rationale).
// MUI <DatePicker> that opens the calendar when the user clicks ANYWHERE in the
// field (not just the calendar icon); manual typing still works. Bundles its own
// <LocalizationProvider> (AdapterMoment). Value/onChange are moment in / moment
// out — the call-site owns conversion to/from the stored string format.

import React, { useState } from "react";
import PropTypes from "prop-types";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export default function AppDatePicker({ slotProps = {}, ...pickerProps }) {
  const [open, setOpen] = useState(false);
  const { textField, ...restSlotProps } = slotProps;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        // Match the familiar old flatpickr display ("14, Jul, 2026").
        // Placed before {...pickerProps} so a call-site can still override.
        format="DD, MMM, YYYY"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        {...pickerProps}
        slotProps={{
          ...restSlotProps,
          textField: {
            fullWidth: true,
            size: "small",
            ...textField,
            onClick: (e) => {
              setOpen(true);
              textField?.onClick?.(e);
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}

AppDatePicker.propTypes = {
  slotProps: PropTypes.object,
};
